import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Svg } from "assets";
import { authActions, httpRequestsOnSuccessActions } from "store";
import { ButtonMain, InputMain } from "components";
import { AuthModalHeaders, IfRemember } from "./fragments";
import { FindError, FindSuccess, Notify, useModal } from "utils";

const ACTION_TYPE_RESET = "RESET_PASSWORD";
const ACTION_TYPE_COMPLETE_REGISTRATION = "COMPLETING_REGISTRATION";

export const ResetPassword = ({ currentToken }) => {
  const ACTION_TYPE = currentToken?.register
    ? ACTION_TYPE_COMPLETE_REGISTRATION
    : ACTION_TYPE_RESET;
  const dispatch = useDispatch();
  const success = FindSuccess(ACTION_TYPE);
  const backError = FindError(ACTION_TYPE);
  const { close } = useModal();
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      newPassword: "",
      confirmation: "",
    },
  });
  useEffect(() => {
    if (backError?.error) {
      Notify(backError?.error);
      close();
    }
  }, [backError]);

  useEffect(() => {
    if (success) {
      close();
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    }
  }, [success]);

  const onSubmit = (data) => {
    const { newPassword, confirmation } = data;
    const params = {
      newPassword,
      confirmation,
      token: currentToken?.register
        ? currentToken?.register
        : currentToken?.resetToken,
      type: currentToken?.register ? "register" : "reset",
    };
    if (currentToken?.register) {
      dispatch(authActions.completeRegistration(params));
    } else {
      dispatch(authActions.resetPassword(params));
    }
  };

  return (
    <div className="auth-modals">
      <AuthModalHeaders
        title={
          currentToken?.register ? "Complete Registration" : "Reset Password"
        }
        subtitle={
          currentToken?.register
            ? "You have been invited to join your account. Please create your password to complete your registration."
            : ""
        }
        icon={currentToken?.register ? <Svg.WelcomeAboard /> : <Svg.Recover />}
      />
      <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
        <InputMain
          name="newPassword"
          type="password"
          control={control}
          placeholder="Password"
          labelHeader="New Password"
          minLength={8}
          rules={{
            required: "This Field is required",
          }}
          startAdornment={<Svg.Lock />}
        />

        <InputMain
          name="confirmation"
          type="password"
          control={control}
          placeholder="Password"
          minLength={8}
          labelHeader={`${
            currentToken?.register ? "Password" : "Confirm Password"
          }`}
          rules={{
            required: "This Field is required",
            validate: (value) => {
              return (
                value === watch("newPassword") ||
                "Password and confirm password does not match"
              );
            },
          }}
          startAdornment={<Svg.Lock />}
        />
        <ButtonMain
          actionTye={ACTION_TYPE}
          text={`${currentToken?.register ? "Join" : "Reset"}`}
          type="submit"
        />
        <IfRemember />
      </form>
    </div>
  );
};
